angular.module('app.services').service('clientsService', function (api) {
    const Service = this;

    Service._model = api('client');

    Service.getAll = () => {
        return Service._model.list().then((response) => response.data);
    };

    Service.getFiltered = (values) => {
        const params = {
            data: {
                filter: values,
            },
        };

        return Service._model.filter(params).then((response) => response.data);
    };

    Service.selectize = () =>
        Service._model
            .selectize({
                transform: {
                    id: 'id',
                    value: ':name',
                },
            })
            .then((response) => _.sortBy(response.data, 'label'));

    Service.find = (id) => Service._model.get(id).then((response) => response.data);

    Service.findForFilter = (id) =>
        Service._model.get(id).then(function (client) {
            return [
                {
                    id: client.id,
                    name: client.name,
                },
            ];
        });

    Service.save = (group) => Service._model.post(group);
});
